import React, { useEffect } from "react";
import Style from '../Styles/DashboardStyle.module.css';
import { Link, useLocation, useNavigate  } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { userlogout } from "../../store/authSlice";
import constants from "../../services/constants";
const DashBoardLeftProfileMenu =()=>{
  const smoothScroll = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const navigate = useNavigate();
      const dispatch = useDispatch();
  let location = useLocation();
  const dashboardClass = location.pathname.match(/^\/dashboard/) ? "active" : "";
  const myOfferClass = location.pathname.match(/^\/myoffer/) ? "active" : "";
  const membershipClass = location.pathname.match(/^\/membership/) ? "active" : "";
  const businessdirectoryClass = location.pathname.match(/^\/mybusinessdirectory/) ? "active" : "";
  const postListingClass = location.pathname.match(/^\/postListing/) ? "active" : "";
  const jobsListingClass = location.pathname.match(/^\/job-listing/) ? "active" : "";
  const eventPassClass = location.pathname.match(/^\/myevent/) ? "active" : "";
  const editProfileClass = location.pathname.match(/^\/edit-profile/) ? "active" : "";
  const changepasswordClass = location.pathname.match(/^\/change-password/) ? "active" : "";

  const { user, isAuthenticated } = useSelector((state) => state.auth);
   const handleLogout = () => {
          // Remove token from local storage
          localStorage.removeItem('token');
          localStorage.removeItem('userDetail');
          dispatch(userlogout());
          // Redirect to home or login page
          navigate('/');
      };
      const removeMenuToggle = () => {
        document.body.classList.remove("active");
      };
      useEffect(() => {
        return () => {
          document.body.classList.remove("active");
        };
      }, []);
    
    return(
      <div className={'deshboardMenu ' + Style.ProfileView}>
        <div className={Style.UserDetail}>
          {user.image && <figure><img  alt="" src={user.image!==null && constants.IMAGE_BASE_URL+'alumni/'+user.image} /></figure>}
          {user &&<h6>{user.name}</h6>}
          <span className={Style.UserId}>{user.id_number}</span>
        </div>

        <div className={'showMenu ' + Style.profileList}>
          <button onClick={removeMenuToggle} type="button" className={Style.closeProfileMenu}><img  alt=""  src={require('../../assest/images/menuCloseIcon.png')} /></button>
          <ul>
            <li className={dashboardClass}>
              <Link to="/dashboard" >
                <span><img  alt=""  src={require('../../assest/images/dashboard-icon.png')} /></span>
                <p>Dashboard</p>
              </Link >
            </li>
            <li className={membershipClass}>
              <Link to="/membership" >
                <span><img  alt=""  src={require('../../assest/images/membership-icon.png')}/></span>
                <p>Membership</p>
              </Link >
            </li>
            <li className={businessdirectoryClass}>
              <Link to="/mybusinessdirectory" >
                <span><img  alt=""  src={require('../../assest/images/user-icon.png')}/></span>
                <p>Business Listing</p>
              </Link >
            </li>
            <li className={postListingClass}>
              <Link to="/postListing" >
                <span><img  alt=""  src={require('../../assest/images/user-icon.png')}/></span>
                <p>Posts Listing</p>
              </Link >
            </li>
            <li className={jobsListingClass}>
              <Link to="/job-listing">
                <span><img  alt=""  src={require('../../assest/images/job-icon.png')}/></span>
                <p>Jobs Listing</p>
              </Link >
            </li>
            <li className={eventPassClass}>
              <Link to="/myevent" >
                <span><img  alt=""  src={require('../../assest/images/event-icon.png')}/></span>
                <p>Events Passes</p>
              </Link >
            </li>
            <li className={myOfferClass}>
              <Link to="/myoffer" >
                <span><img  alt=""  src={require('../../assest/images/offer-icon.png')}/></span>
                <p>Offers Posted</p>
              </Link >
            </li>
            <li className={editProfileClass}>
              <Link to="/edit-profile" >
                <span><img  alt=""  src={require('../../assest/images/edit-pro-icon.png')}/></span>
                <p>Edit Profile</p>
              </Link >
            </li>
            <li className={changepasswordClass}>
              <Link to="/change-password" >
                <span><img  alt=""  src={require('../../assest/images/change-password-icon.png')}/></span>
                <p>Change Password</p>
              </Link >
            </li>
            <li className={Style.MobLogout}>
              {isAuthenticated && 
                <Link to="/" onClick={handleLogout}>
                  <span><img  alt=""  src={require('../../assest/images/logoutIcon.png')}/></span>
                  <p>Logout</p>
                </Link>
              }
            </li>
          </ul> 
        </div>
      </div>
    )
}

export default DashBoardLeftProfileMenu;